import React, { useContext } from "react";
import Category from "./Category"
import { Card, CardBody, CardHeader } from "reactstrap";
import { MenuContext } from "../MenuSnooze";

const translator = require("../../../../utils/translator/translator");

function CategoriesContainer()
{
    const { selectedMenu } = useContext(MenuContext);
    return (
        <Card style={{ height: "85vh" }}>
            <CardHeader>{translator.getLabel("categories")}</CardHeader>
            <CardBody style={{ overflow: 'auto' }}>
                <div className="d-flex flex-column gap-2 h-100">
                    {
                        (Array.isArray(selectedMenu.categories) && selectedMenu.categories.length > 0)
                            ? selectedMenu.categories.map((category, index) => (
                                <Category key={`${index}-${category.caption}`} menuCategory={category} />
                            ))
                            : <div className="d-flex h-100 justify-content-center align-items-center">
                                <h5 style={{ color: "var(--colors-text-light)" }}>{translator.getLabel("no_categories_in_this_menu")}</h5>
                            </div>
                    }
                </div>
            </CardBody>
        </Card>
    )
}

export default CategoriesContainer;